import { Box, IconButton, Tooltip } from "@mui/material";
import React, { forwardRef } from "react";
import { IResponsiveSizes } from "../../../hooks/useResponsiveSizes";
import { primaryIconActive, primaryIconInactive } from "../../../utils/colors";

export interface ToolbarButtonProps {
  tooltip: string;
  onClick?: () => void;
  active?: boolean;
  buttonRef?: React.Ref<any>; // Keep for backward compatibility
  onMouseDown?: React.MouseEventHandler;
  onMouseUp?: React.MouseEventHandler;
  onTouchStart?: React.TouchEventHandler;
  onTouchEnd?: React.TouchEventHandler;
  icon: React.ReactNode;
  children?: React.ReactNode;
  sx?: object;
  sizes?: IResponsiveSizes;
}

const ToolbarButton = forwardRef<HTMLButtonElement, ToolbarButtonProps>(
  (
    {
      tooltip,
      onClick,
      active,
      buttonRef, 
      onMouseDown,
      onMouseUp,
      onTouchStart,
      onTouchEnd,
      icon,
      children,
      sx = {},
      sizes,
    },
    ref
  ) => {
    const color = active ? primaryIconActive : primaryIconInactive;

    const computedIcon =
      React.isValidElement(icon) && sizes?.toolbarButtonFontSize
        ? React.cloneElement(icon as React.ReactElement<any>, {
            sx: {
              fontSize: sizes.toolbarButtonFontSize,
              ...(icon.props.sx || {}),
            },
          })
        : icon;

    return (
      <Box component="div" sx={{ position: "relative" }}>
        <Tooltip title={tooltip} placement="right">
          <IconButton
            ref={ref || buttonRef} // Use new ref first, fallback to old prop
            onClick={onClick}
            onMouseDown={onMouseDown}
            onMouseUp={onMouseUp}
            onTouchStart={onTouchStart}
            onTouchEnd={onTouchEnd}
            size="large"
            sx={{ color, ...sx }}
          >
            {computedIcon}
            {children}
          </IconButton>
        </Tooltip>
      </Box>
    );
  }
);

export default ToolbarButton;